import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { UserPlus, Phone, Loader2, Eye } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const LeadAssignBlockingPopup = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    if (!user) return;
    try { const { data } = await axios.get(`${API_URL}/lead-assign-alerts/pending`); setRows(Array.isArray(data) ? data : []); } catch { /* silent */ }
  }, [user]);
  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, [load]);

  if (!user || !rows.length) return null;
  const a = rows[0];
  const many = a.count > 1;

  const seen = async (goTo) => {
    setBusy(true);
    try {
      await axios.post(`${API_URL}/lead-assign-alerts/${a.id}/seen`);
      setRows((r) => r.slice(1));
      if (goTo) navigate(goTo);
    } catch (e) {
      toast.error((typeof e.response?.data?.detail === 'string' && e.response.data.detail) || 'Erro');
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[9997] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" data-testid="lead-assign-popup">
      <div className="w-full max-w-md rounded-2xl overflow-hidden bg-white shadow-2xl animate-in zoom-in-95 duration-300">
        <div className="bg-[#2D3E6F] px-6 py-4 text-white flex items-center gap-3">
          <span className="w-10 h-10 rounded-full bg-[#4DD4E8] text-[#2D3E6F] flex items-center justify-center"><UserPlus className="w-5 h-5" /></span>
          <div className="flex-1">
            <p className="text-[10px] uppercase tracking-widest text-white/75 font-bold">{many ? 'Novas leads atribuídas' : 'Nova lead atribuída'}</p>
            <p className="font-bold">Por {a.assigned_by_name}</p>
          </div>
          {rows.length > 1 && <span className="text-xs font-bold bg-white/20 px-2 py-1 rounded-full">1 de {rows.length}</span>}
        </div>
        <div className="p-6 space-y-4">
          {many ? (
            <p className="text-lg font-semibold text-slate-800" data-testid="lead-assign-popup-text">Foram-te atribuídas {a.count} leads.</p>
          ) : (
            <div className="rounded-xl bg-slate-50 border border-slate-200 p-4 space-y-1" data-testid="lead-assign-popup-text">
              <p className="text-lg font-semibold text-slate-800">{a.client_name || 'Cliente'}</p>
              {a.client_phone && <p className="text-sm text-slate-600 inline-flex items-center gap-1"><Phone className="w-3.5 h-3.5" />{a.client_phone}</p>}
              {a.service_interest && <p className="text-xs text-slate-500">{a.service_interest}</p>}
            </div>
          )}
          <p className="text-xs text-slate-500">Tem 24h para fazer o primeiro contacto. O gestor fica a saber quando viu a lead.</p>
          <div className="flex flex-col sm:flex-row gap-2">
            <Button variant="outline" disabled={busy} onClick={() => seen(null)} className="flex-1 gap-2" data-testid="lead-assign-popup-seen">
              <Eye className="w-4 h-4" />Vi a lead
            </Button>
            <Button disabled={busy} onClick={() => seen(many ? '/leads/pipeline' : `/leads/${a.lead_ids[0]}`)} className="flex-1 bg-emerald-600 hover:bg-emerald-700 gap-2" data-testid="lead-assign-popup-open">
              {busy && <Loader2 className="w-4 h-4 animate-spin" />}{many ? 'Ver as minhas leads' : 'Abrir lead'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
